<template>
  <div class="row">
    <div class="col-12">
      <h2>{{ $t('payment_provider_accounts.edit') }}</h2>
    </div>

    <div class="col-12 mt-4">
      <form class="row" @submit.prevent="updatePaymentProviderAccount">
        <FormFields v-model:formData="formData"/>
        <div class="col-12 col-lg-3 mt-3">
          <button class="btn btn-success" type="submit" :disabled="saving">
            {{ $t('save') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {usePaymentProviderAccountStore} from "@/stores/payment_provider_account";
import {Helpers} from "@/helpers";
import {ROUTES} from "@/scripts/constants";
import FormFields from "@/pages/payment_provider_accounts/components/FormFields.vue";

export default {
  name: 'PaymentProviderAccountsEdit',
  components: {
    FormFields,
  },
  setup() {
    return {
      paymentProviderAccountStore: usePaymentProviderAccountStore(),
    }
  },
  data() {
    return {
      formData: {
        organization_id: '',
        provider_key: '',
        name: '',
        status: '',
        api_key: '',
        profile_id: '',
        default_currency: 'EUR',
        webhook_url: '',
      },
      saving: false,
    }
  },
  created() {
    this.paymentProviderAccountStore.show(this.$route.params.id).then(() => {
      const account = this.paymentProviderAccountStore.payment_provider_account
      this.formData = {
        organization_id: account.organization_id,
        provider_key: account.provider_key || '',
        name: account.name || '',
        status: account.status || '',
        api_key: '',
        profile_id: account.profile_id || '',
        default_currency: account.default_currency || '',
        webhook_url: account.webhook_url || '',
      }
      this.setTitle(this.$t('payment_provider_accounts.edit'))
    })
  },
  methods: {
    buildPayload() {
      const payload = {
        organization_id: this.formData.organization_id === '' ? null : Number(this.formData.organization_id),
        provider_key: this.formData.provider_key,
        name: this.formData.name,
        status: this.formData.status,
        profile_id: this.formData.profile_id,
        default_currency: this.formData.default_currency,
        webhook_url: this.formData.webhook_url,
      }
      if (this.formData.api_key) {
        payload.api_key = this.formData.api_key
      }
      return payload
    },
    updatePaymentProviderAccount() {
      const payload = this.buildPayload()
      this.saving = true
      this.paymentProviderAccountStore.update(this.$route.params.id, payload).then(() => {
        Helpers.emitter.emit('success', this.$t('payment_provider_accounts.updated'))
        this.$router.push({name: ROUTES.PAYMENT_PROVIDER_ACCOUNTS.SHOW, params: {id: this.$route.params.id}})
      }).finally(() => {
        this.saving = false
      })
    }
  }
}
</script>
